var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 15.2073C7.54016 15.2073 7.10683 14.974 6.80016 14.5673L5.80016 13.234C5.78016 13.2073 5.70016 13.174 5.66683 13.1673H5.3335C2.5535 13.1673 0.833496 12.414 0.833496 8.66732V5.33398C0.833496 2.38732 2.38683 0.833984 5.3335 0.833984H10.6668C13.6135 0.833984 15.1668 2.38732 15.1668 5.33398V8.66732C15.1668 11.614 13.6135 13.1673 10.6668 13.1673H10.3335C10.2802 13.1673 10.2335 13.194 10.2002 13.234L9.20016 14.5673C8.8935 14.974 8.46016 15.2073 8.00016 15.2073ZM5.3335 1.83398C2.94683 1.83398 1.8335 2.94732 1.8335 5.33398V8.66732C1.8335 11.6807 2.86683 12.1673 5.3335 12.1673H5.66683C6.00683 12.1673 6.3935 12.3607 6.60016 12.634L7.60016 13.9673C7.8335 14.274 8.16683 14.274 8.40016 13.9673L9.40016 12.634C9.62016 12.3407 9.96683 12.1673 10.3335 12.1673H10.6668C13.0535 12.1673 14.1668 11.054 14.1668 8.66732V5.33398C14.1668 2.94732 13.0535 1.83398 10.6668 1.83398H5.3335Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3332 5.83398H4.6665C4.39317 5.83398 4.1665 5.60732 4.1665 5.33398C4.1665 5.06065 4.39317 4.83398 4.6665 4.83398H11.3332C11.6065 4.83398 11.8332 5.06065 11.8332 5.33398C11.8332 5.60732 11.6065 5.83398 11.3332 5.83398Z",
    fill: "#757575"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6665 9.16602H4.6665C4.39317 9.16602 4.1665 8.93935 4.1665 8.66602C4.1665 8.39268 4.39317 8.16602 4.6665 8.16602H8.6665C8.93984 8.16602 9.1665 8.39268 9.1665 8.66602C9.1665 8.93935 8.93984 9.16602 8.6665 9.16602Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageText);
export default __webpack_public_path__ + "static/media/message-text.d1da69d5.svg";
export { ForwardRef as ReactComponent };